import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

const consumer = createConsumer();

export default class extends Controller {
  static values = { chatId: String, signedStreamName: String, }
  static targets = ["messages", "submitButton", "questionInput", "messagesScrollarea", "welcomeState"]

  connect() {
    if (this.chatIdValue) {
      this.subscribeToChat()
    }
  }

  postMessage(event) {
    let chatId;
    let signedStreamName;

    // State 1 - No chat initialised
    if (!this.chatIdValue) {
      console.log("📩 postMessage called - No chat initialised");

      chatId = event.detail.fetchResponse.response.headers.get("X-Chat-Id");
      signedStreamName = event.detail.fetchResponse.response.headers.get("X-Signed-Stream-Name");
      // Update the hidden field with the new chat ID
      const chatIdField = document.querySelector('input[name="chat_id"]');

      // Remove the welcome state.
      const welcomeState = this.welcomeStateTarget
      if (welcomeState) {
        welcomeState.remove();
      }

      if (chatIdField) {
        chatIdField.value = chatId;
      } else {
        console.warn("⚠️ Could not find chat_id hidden field to update");
      }
    } else {
      // State 2 - Chat initialised
      chatId = this.chatIdValue;
      signedStreamName = this.signedStreamNameValue;
    }

    if (chatId && signedStreamName) {
      this.chatIdValue = chatId;
      this.signedStreamNameValue = signedStreamName;
      console.log(this.subscription)
      if (!this.subscription) {
        console.log("📩postMessage called - Chat initialised - subscribing to chat");
        this.subscribeToChat();
      }
    }

    // Clear the content field after submission
    const contentField = document.querySelector('textarea[name="content"]');
    if (contentField) {
      contentField.value = '';
    } else {
      console.warn("⚠️ Could not find content field to clear");
    }

    this.scrollToBottom();
  }

  subscribeToChat() {
    if (!this.signedStreamNameValue) {
      console.error("❌ No signed stream name available. Subscription failed.");
      return;
    }

    console.log(`✅ Subscribing to chat stream: ${this.signedStreamNameValue}`);

    this.subscription = consumer.subscriptions.create(
      {
        channel: "Turbo::StreamsChannel",
        signed_stream_name: this.signedStreamNameValue
      },
      {
        received: (data) => {
          console.log("📩 received called");
          if (!data.includes("turbo-stream")) {
            console.warn("⚠️ No turbo-stream tag in data:", data);
            return;
          }

          const fragment = document.createRange().createContextualFragment(data);
          this.checkForFinalMessage(data);
          this.messagesTarget.append(fragment);
          this.scrollToBottom();
        }
      }
    );
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null;
    }
  }

  disableSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
    }
  }

  checkForFinalMessage(data) {
    if (data.includes('data-msg-final="true"')) {
      this.enableSubmitButton();
    }
  }

  enableSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false;
    }
  }

  chatWindowLoaded() {
    // This method is called from an existing chat, and also from "new chat". For existing chats, chatId and signedStream are populated
    // for new chats they are empty.

    // Reset the chat ID value when the chat window is loaded
    this.chatIdValue = "";
    this.signedStreamNameValue = "";

    const chatId = document.querySelector('[data-chat_subscription_chat_id_value]')?.dataset.chat_subscription_chat_id_value;
    const signedStream = document.querySelector('[data-chat_subscription_signed_stream_name_value]')?.dataset.chat_subscription_signed_stream_name_value;

    if (chatId) this.chatIdValue = chatId;
    if (signedStream) this.signedStreamNameValue = signedStream;

    if (this.subscription) {
      console.log("✅ Chat window loaded - unsubscribing from chat");
      this.subscription.unsubscribe()
      this.subscription = null;
    }
    if (this.chatIdValue && this.signedStreamNameValue) {
      console.log("✅ Chat window loaded - subscribing to chat");
      this.subscribeToChat();
    }

    this.scrollToBottom();
  }

  submitOnEnter(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.submitButtonTarget.click();
    }
  }

  setQuestion(event) {
    const question = event.currentTarget.dataset.question;
    if (this.hasQuestionInputTarget) {
      this.questionInputTarget.value = question;
      this.questionInputTarget.focus();
    }
  }

  scrollToBottom() {
    const messagesContainer = document.querySelector('[data-chat-subscription-target="messages-scrollarea"]');
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  }
}